export default __webpack_public_path__ + "static/photo_1-d93bdc3e4ff1ed04ef24177e8279f879.png";